import { render, staticRenderFns } from "./leftBody.vue?vue&type=template&id=91721a48&scoped=true&"
import script from "./leftBody.vue?vue&type=script&lang=js&"
export * from "./leftBody.vue?vue&type=script&lang=js&"
import style0 from "./leftBody.vue?vue&type=style&index=0&id=91721a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91721a48",
  null
  
)

export default component.exports